/* GRAVURWELT Textil-Konfigurator
 * Preise kommen ausschließlich aus Shopify-Varianten:
 *   Textil:   Farbe × Größe × Preisliste (Privat | Gewerbe 1–9 | 10–24 | 25–49 | ab 50) – per ?view=gw-varmap nachgeladen
 *   Stick:    gw-baustein-stick  (Motiv × Preisstufe × Position)
 *   Druck:    gw-baustein-druck  (Motiv × Preisstufe)
 *   Service:  gw-baustein-einrichtung (Leistung × Preisliste)
 */
(function () {
  var root = document.querySelector('[data-kfg]');
  if (!root) return;
  var D = JSON.parse(root.querySelector('[data-kfg-data]').textContent);
  var GW = window.GW || {};
  var fmt = GW.fmt || function (c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; };
  var net = GW.net || function (c) { return Math.round(c / 1.19); };
  var isB2B = GW.isB2B || function () { return false; };
  var ROOT_URL = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var STUFEN = ['1–4', '5–9', '10–24', '25–49', 'ab 50'];
  var LISTEN_B2B = ['Gewerbe 1–9', 'Gewerbe 10–24', 'Gewerbe 25–49', 'Gewerbe ab 50'];
  var STICK_MOTIV = { A: 'Schriftzug / Name', B: 'Kleines Logo', C: 'Mittleres Motiv', D: 'Großes Motiv' };
  var STICK_INFO = { A: 'bis 3.000 Stiche · einzeilig, ca. 10 cm breit, Standardschrift', B: 'bis 6.000 Stiche · ca. 10 × 8 cm, z. B. Brustlogo', C: 'bis 12.000 Stiche · ca. 15 × 15 cm', D: 'bis 25.000 Stiche · ca. 25 × 25 cm, nur Sweat, Hoodie, Jacke' };
  var DRUCK_MOTIV = { S: 'Klein', M: 'Mittel', L: 'Groß', Z: 'Ärmel / Nacken' };
  var DRUCK_INFO = { S: 'bis ca. 10 × 10 cm, z. B. Brustlogo', M: 'bis ca. 20 × 20 cm, z. B. Front mittig', L: 'bis ca. 30 × 40 cm, großer Front- oder Rückendruck', Z: 'bis ca. 100 cm², nur zusätzlich zu einer weiteren Position' };
  // Veredelungspositionen je Kleidungsart (data-kfg-data.kind: shirt | hoodie | zip | jacke | hose)
  var POS = {
    shirt: { stick: ['Brust links', 'Brust rechts', 'Front mittig', 'Rücken oben', 'Rücken groß', 'Nacken', 'Ärmel links', 'Ärmel rechts'],
             druck: ['Brust links', 'Brust rechts', 'Front mittig', 'Rücken oben', 'Rücken groß', 'Ärmel links', 'Ärmel rechts', 'Nacken'] },
    hoodie: { stick: ['Brust links', 'Brust rechts', 'Front mittig', 'Rücken oben', 'Rücken groß', 'Nacken', 'Ärmel links', 'Ärmel rechts', 'Kapuze', 'Tasche'],
              druck: ['Brust links', 'Brust rechts', 'Front mittig', 'Rücken oben', 'Rücken groß', 'Ärmel links', 'Ärmel rechts', 'Nacken'] },
    zip: { stick: ['Brust links', 'Brust rechts', 'Rücken oben', 'Rücken groß', 'Nacken', 'Ärmel links', 'Ärmel rechts', 'Kapuze'],
           druck: ['Brust links', 'Brust rechts', 'Rücken oben', 'Rücken groß', 'Ärmel links', 'Ärmel rechts', 'Nacken'] },
    jacke: { stick: ['Brust links', 'Brust rechts', 'Rücken oben', 'Rücken groß', 'Ärmel links', 'Ärmel rechts'],
             druck: ['Brust links', 'Brust rechts', 'Rücken oben', 'Rücken groß', 'Ärmel links', 'Ärmel rechts'] },
    hose: { stick: ['Bein links', 'Bein rechts'], druck: ['Bein links', 'Bein rechts'] },
    cap: { stick: ['Front', 'Seite links', 'Seite rechts', 'Rücken'], druck: [] }
  };
  var KIND = POS[D.kind] ? D.kind : 'shirt';
  var CAP = KIND === 'cap';
  if (CAP) {
    // Caps: nur Stick, eigene Motivstufen (Kappenrahmen)
    STICK_MOTIV = { A: 'Schriftzug / Name', B: 'Frontlogo', C: 'Großes Frontlogo', Z: 'Zusatz Seite/Rücken' };
    STICK_INFO = { A: 'bis 3.000 Stiche · ca. bis 10 × 3 cm · Front, Seite oder Rücken', B: 'bis 6.000 Stiche · ca. bis 10 × 5,5 cm', C: 'bis 10.000 Stiche · ca. bis 12 × 6 cm · nach technischer Prüfung', Z: 'bis 3.000 Stiche · ca. bis 6 × 3 cm · nur zusätzlich zu einem Frontstick' };
  }
  function progKey(p) { return CAP && p.motiv === 'Z' ? 'A' : p.motiv; }
  var POS_STICK = POS[KIND].stick;
  var POS_DRUCK = POS[KIND].druck;
  var ERSCHWERT = ['Ärmel links', 'Ärmel rechts', 'Kapuze', 'Tasche', 'Bein links', 'Bein rechts'];
  var DRUCK_Z = ['Ärmel links', 'Ärmel rechts', 'Nacken'];
  var SETUP = { neu: 'Neues Stickprogramm', datei: 'Eigene Stickdatei (DST/EXP/PES)', vorhanden: 'Programm vorhanden / gleiches Motiv' };

  var state = { rows: [], positions: [], cache: {}, loading: 0 };
  var el = {
    rows: root.querySelector('[data-kfg-rows]'),
    addColor: root.querySelector('[data-kfg-addcolor]'),
    positions: root.querySelector('[data-kfg-positions]'),
    addPos: root.querySelector('[data-kfg-addpos]'),
    summary: root.querySelector('[data-kfg-summary]'),
    error: root.querySelector('[data-kfg-error]'),
    add: root.querySelector('[data-kfg-add]')
  };
  var mainImg = document.querySelector('[data-main-image]');

  /* ---------- Hilfen ---------- */
  function h(tag, attrs, html) {
    var e = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) { if (attrs[k] !== null && attrs[k] !== undefined) e.setAttribute(k, attrs[k]); });
    if (html !== undefined) e.innerHTML = html;
    return e;
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function show(c) { return isB2B() ? fmt(net(c)) : fmt(c); }
  function total() {
    return state.rows.reduce(function (s, r) { return s + Object.keys(r.qty).reduce(function (a, k) { return a + (r.qty[k] || 0); }, 0); }, 0);
  }
  function group() { return isB2B() ? 'Gewerbe' : 'Privat'; }
  function liste(n) {
    if (!isB2B()) return 'Privat';
    return n >= 50 ? LISTEN_B2B[3] : n >= 25 ? LISTEN_B2B[2] : n >= 10 ? LISTEN_B2B[1] : LISTEN_B2B[0];
  }
  function stufe(n) { var s = n >= 50 ? 4 : n >= 25 ? 3 : n >= 10 ? 2 : n >= 5 ? 1 : 0; return group() + ' ' + STUFEN[s]; }
  function findBaustein(list, test) { for (var i = 0; i < list.length; i++) if (test(list[i].o)) return list[i]; return null; }
  function stickVar(m, st, pos) {
    if (CAP) return findBaustein(D.stick, function (o) { return o[0].indexOf(m + ' ') === 0 && o[1] === st; });
    var kind = ERSCHWERT.indexOf(pos) > -1 ? 'Erschwert' : 'Standard';
    return findBaustein(D.stick, function (o) { return o[0].indexOf(m + ' ') === 0 && o[1] === st && o[2] === kind; });
  }
  function druckVar(m, st) { return findBaustein(D.druck, function (o) { return o[0].indexOf(m + ' ') === 0 && o[1] === st; }); }
  function svcVar(prefix) { return findBaustein(D.svc, function (o) { return o[0].indexOf(prefix) === 0 && o[1] === group(); }); }
  function colorByName(n) { for (var i = 0; i < D.colors.length; i++) if (D.colors[i].name === n) return D.colors[i]; return null; }
  function listByName(n) { for (var i = 0; i < D.lists.length; i++) if (D.lists[i].name === n) return D.lists[i]; return null; }

  /* ---------- Textilpreise nachladen ---------- */
  function key(color, list) { return color + '|' + list; }
  function load(colorName, listName) {
    var k = key(colorName, listName);
    if (state.cache[k]) return Promise.resolve(state.cache[k]);
    if (state.cache[k + ':p']) return state.cache[k + ':p'];
    var c = colorByName(colorName), l = listByName(listName);
    if (!c || !l) return Promise.resolve(null);
    state.loading++;
    var attempt = function (i) {
      if (i >= D.sizes.length) return Promise.resolve({});
      var url = D.url + '?view=gw-varmap&option_values=' + [c.ov, D.sizes[i].ov, l.ov].join(',');
      return fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (j) {
        var map = {}, ok = false;
        (j.second || []).forEach(function (s) {
          if (s.id && s.options && s.options[0] === colorName && s.options[2] === listName) { map[s.name] = s; ok = true; }
        });
        return ok ? map : attempt(i + 1);
      });
    };
    var p = attempt(0).then(function (map) {
      state.cache[k] = map; state.loading--; return map;
    }).catch(function () { state.loading--; state.cache[k] = {}; return {}; });
    state.cache[k + ':p'] = p;
    return p;
  }
  function ensurePrices() {
    var l = liste(total());
    var jobs = state.rows.map(function (r) { return load(r.color, l); });
    // Für den Hinweis „nächste Staffel“ auch die nächste Preisliste vorladen
    return Promise.all(jobs).then(render);
  }

  /* ---------- Farben & Größen ---------- */
  function addRow(colorName) {
    var used = state.rows.map(function (r) { return r.color; });
    if (!colorName) {
      for (var i = 0; i < D.colors.length; i++) if (used.indexOf(D.colors[i].name) === -1) { colorName = D.colors[i].name; break; }
    }
    if (!colorName) return;
    var row = { color: colorName, qty: {} };
    state.rows.push(row);
    buildRows();
    setImage(colorName);
    ensurePrices();
  }
  function setImage(colorName) {
    var c = colorByName(colorName);
    if (c && c.img && mainImg) { mainImg.src = c.img; mainImg.removeAttribute('srcset'); mainImg.alt = D.title + ' – ' + colorName; }
  }
  function buildRows() {
    el.rows.innerHTML = '';
    state.rows.forEach(function (row, ri) {
      var box = h('div', { 'class': 'kfg__row' });
      var head = h('div', { 'class': 'kfg__rowhead' });
      var lab = h('label', { 'for': 'kfg-c-' + ri }, 'Farbe');
      var sel = h('select', { 'class': 'in', id: 'kfg-c-' + ri });
      D.colors.forEach(function (c) {
        var taken = state.rows.some(function (r, j) { return j !== ri && r.color === c.name; });
        var o = h('option', { value: c.name }, esc(c.name));
        if (taken) o.disabled = true;
        if (c.name === row.color) o.selected = true;
        sel.appendChild(o);
      });
      sel.addEventListener('change', function () { row.color = sel.value; setImage(row.color); buildRows(); ensurePrices(); });
      head.appendChild(h('div', { 'class': 'kfg__colorsel' })).appendChild(lab).parentNode.appendChild(sel);
      if (state.rows.length > 1) {
        var rm = h('button', { type: 'button', 'class': 'linkbtn small' }, 'Farbe entfernen');
        rm.addEventListener('click', function () { state.rows.splice(ri, 1); buildRows(); ensurePrices(); });
        head.appendChild(rm);
      }
      box.appendChild(head);
      var grid = h('div', { 'class': 'kfg__sizes' });
      D.sizes.forEach(function (s) {
        var cell = h('div', { 'class': 'kfg__size' });
        var id = 'kfg-q-' + ri + '-' + s.name.replace(/\W/g, '');
        cell.appendChild(h('label', { 'for': id }, esc(s.name)));
        var inp = h('input', { 'class': 'in', type: 'number', min: '0', step: '1', inputmode: 'numeric', id: id, placeholder: '0', 'data-size': s.name, 'data-row': ri });
        if (row.qty[s.name]) inp.value = row.qty[s.name];
        inp.addEventListener('input', function () {
          var v = parseInt(inp.value, 10);
          row.qty[s.name] = isNaN(v) || v < 0 ? 0 : v;
          ensurePrices();
        });
        cell.appendChild(inp);
        cell.appendChild(h('span', { 'class': 'kfg__unit', 'data-unit': s.name, 'data-row': ri }, ''));
        grid.appendChild(cell);
      });
      box.appendChild(grid);
      el.rows.appendChild(box);
    });
    el.addColor.hidden = state.rows.length >= D.colors.length;
  }

  /* ---------- Positionen ---------- */
  function addPosition(type) {
    var used = state.positions.map(function (p) { return p.pos; });
    var list = type === 'druck' ? POS_DRUCK : POS_STICK;
    var pos = list.filter(function (x) { return used.indexOf(x) === -1; })[0] || list[0];
    var np = { type: CAP ? 'stick' : (type || 'stick'), pos: pos, motiv: type === 'druck' ? 'S' : 'B', setup: 'neu', grafik: '', note: '', file: null };
    if (CAP && pos !== 'Front') np.motiv = state.positions.some(function (x) { return x.pos === 'Front'; }) ? 'Z' : 'A';
    state.positions.push(np);
    buildPositions(); render();
  }
  function motifOptions(p) {
    if (CAP) return p.pos === 'Front' ? ['A', 'B', 'C'] : ['A', 'Z'];
    if (p.type === 'stick') return ['A', 'B', 'C'].concat(D.heavy ? ['D'] : []);
    if (DRUCK_Z.indexOf(p.pos) > -1) return ['Z'];
    if (KIND === 'hose') return ['S', 'M']; // Hosenbein: max. ca. 20 × 20 cm
    return ['S', 'M', 'L'];
  }
  function buildPositions() {
    el.positions.innerHTML = '';
    state.positions.forEach(function (p, pi) {
      var box = h('fieldset', { 'class': 'kfg__pos' });
      box.appendChild(h('legend', null, 'Position ' + (pi + 1)));
      // Art
      var art = h('div', { 'class': 'kfg__art' });
      (CAP ? [['stick', 'Stick']] : [['stick', 'Stick'], ['druck', 'Druck (DTF)']]).forEach(function (t) {
        var lab = h('label', { 'class': 'pill' });
        var r = h('input', { type: 'radio', name: 'kfg-art-' + pi, value: t[0] });
        if (p.type === t[0]) r.checked = true;
        r.addEventListener('change', function () {
          p.type = t[0];
          var list = p.type === 'druck' ? POS_DRUCK : POS_STICK;
          if (list.indexOf(p.pos) === -1) p.pos = list[0];
          var mo = motifOptions(p); if (mo.indexOf(p.motiv) === -1) p.motiv = mo[mo.length > 1 ? 1 : 0];
          buildPositions(); render();
        });
        lab.appendChild(r); lab.appendChild(h('span', null, t[1]));
        art.appendChild(lab);
      });
      box.appendChild(art);
      // Position
      var f1 = h('div', { 'class': 'field' });
      f1.appendChild(h('label', { 'for': 'kfg-p-' + pi }, 'Position'));
      var ps = h('select', { 'class': 'in', id: 'kfg-p-' + pi });
      (p.type === 'druck' ? POS_DRUCK : POS_STICK).forEach(function (x) {
        var extra = !CAP && p.type === 'stick' && ERSCHWERT.indexOf(x) > -1 ? ' (erschwert)' : '';
        var o = h('option', { value: x }, esc(x + extra)); if (x === p.pos) o.selected = true; ps.appendChild(o);
      });
      ps.addEventListener('change', function () {
        p.pos = ps.value;
        var mo = motifOptions(p); if (mo.indexOf(p.motiv) === -1) p.motiv = mo[0];
        buildPositions(); render();
      });
      f1.appendChild(ps); box.appendChild(f1);
      // Motivgröße
      var f2 = h('div', { 'class': 'field' });
      f2.appendChild(h('label', { 'for': 'kfg-m-' + pi }, p.type === 'stick' ? 'Stickmotiv' : 'Druckgröße'));
      var ms = h('select', { 'class': 'in', id: 'kfg-m-' + pi, 'data-motif': pi });
      motifOptions(p).forEach(function (m) {
        var o = h('option', { value: m }, esc((p.type === 'stick' ? STICK_MOTIV[m] : DRUCK_MOTIV[m])));
        if (m === p.motiv) o.selected = true; ms.appendChild(o);
      });
      ms.addEventListener('change', function () { p.motiv = ms.value; buildPositions(); render(); });
      f2.appendChild(ms);
      f2.appendChild(h('span', { 'class': 'muted small' }, esc(p.type === 'stick' ? STICK_INFO[p.motiv] : DRUCK_INFO[p.motiv])));
      box.appendChild(f2);
      // Stickprogramm
      if (p.type === 'stick') {
        var f3 = h('div', { 'class': 'field' });
        f3.appendChild(h('label', { 'for': 'kfg-s-' + pi }, 'Stickprogramm'));
        var ss = h('select', { 'class': 'in', id: 'kfg-s-' + pi, 'data-setup': pi });
        Object.keys(SETUP).forEach(function (k) { var o = h('option', { value: k }, SETUP[k]); if (k === p.setup) o.selected = true; ss.appendChild(o); });
        ss.addEventListener('change', function () { p.setup = ss.value; render(); });
        f3.appendChild(ss); box.appendChild(f3);
      }
      // Grafikservice
      var f4 = h('div', { 'class': 'field' });
      f4.appendChild(h('label', { 'for': 'kfg-g-' + pi }, 'Grafikservice (optional)'));
      var gs = h('select', { 'class': 'in', id: 'kfg-g-' + pi, 'data-grafik': pi });
      [['', 'Nicht nötig – Datei ist druck-/stickfertig'], ['Freistellen', 'Freistellen / Hintergrund entfernen'], ['Vektorisieren', 'Vektorisieren (einfaches Logo)']].forEach(function (x) {
        var o = h('option', { value: x[0] }, x[1]); if (x[0] === p.grafik) o.selected = true; gs.appendChild(o);
      });
      gs.addEventListener('change', function () { p.grafik = gs.value; render(); });
      f4.appendChild(gs); box.appendChild(f4);
      // Upload + Hinweis
      var f5 = h('div', { 'class': 'field' });
      f5.appendChild(h('label', { 'for': 'kfg-f-' + pi }, 'Motiv hochladen (optional)'));
      var fi = h('input', { 'class': 'in', type: 'file', id: 'kfg-f-' + pi, accept: '.png,.jpg,.jpeg,.pdf,.svg,.ai,.eps,.dst,.exp,.pes' });
      fi.addEventListener('change', function () { p.file = fi.files && fi.files[0] ? fi.files[0] : null; });
      f5.appendChild(fi);
      if (p.file) f5.appendChild(h('span', { 'class': 'muted small' }, 'Gewählt: ' + esc(p.file.name)));
      f5.appendChild(h('span', { 'class': 'muted small' }, 'PNG, JPG, PDF, SVG, AI, EPS oder Stickdatei. Du kannst das Motiv auch nach der Bestellung schicken.'));
      box.appendChild(f5);
      var f6 = h('div', { 'class': 'field' });
      f6.appendChild(h('label', { 'for': 'kfg-n-' + pi }, 'Hinweis zum Motiv'));
      var ta = h('textarea', { 'class': 'in', rows: '2', id: 'kfg-n-' + pi, placeholder: 'z. B. Name, Schriftart, Garn- oder Druckfarbe' });
      ta.value = p.note;
      ta.addEventListener('input', function () { p.note = ta.value; });
      f6.appendChild(ta); box.appendChild(f6);
      box.appendChild(h('p', { 'class': 'kfg__posprice', 'data-posprice': pi }, ''));
      var rm = h('button', { type: 'button', 'class': 'linkbtn small' }, 'Position entfernen');
      rm.addEventListener('click', function () { state.positions.splice(pi, 1); buildPositions(); render(); });
      box.appendChild(rm);
      el.positions.appendChild(box);
    });
    el.addPos.hidden = state.positions.length >= 4;
  }

  /* ---------- Berechnung ---------- */
  function calc() {
    var n = total(), l = liste(n), st = stufe(n), lines = [], errors = [];
    var textile = 0, items = [];
    state.rows.forEach(function (r) {
      var map = state.cache[key(r.color, l)];
      var sum = 0, nsum = 0, parts = [];
      Object.keys(r.qty).forEach(function (s) {
        var q = r.qty[s]; if (!q) return;
        var v = map && map[s];
        if (!map) { errors.push('Preise werden geladen …'); return; }
        if (!v || !v.id) { errors.push(r.color + ' in Größe ' + s + ' ist nicht lieferbar.'); return; }
        sum += v.price * q; nsum += net(v.price) * q; parts.push(q + ' × ' + s);
        items.push({ id: v.id, quantity: q, role: 'textil' });
      });
      if (parts.length) { lines.push({ label: 'Textil ' + r.color, detail: parts.join(', '), cents: sum, net: nsum }); textile += sum; }
    });
    var setups = [], posCents = 0;
    state.positions.forEach(function (p, pi) {
      var v = p.type === 'stick' ? stickVar(p.motiv, st, p.pos) : druckVar(p.motiv, st);
      if (!v) { errors.push('Für Position ' + (pi + 1) + ' fehlt ein Preis (Preisbaustein im Shop prüfen).'); return; }
      var label = (p.type === 'stick' ? 'Stick ' : 'Druck ') + p.motiv + ' · ' + p.pos;
      if (n) lines.push({ label: label, detail: n + ' × ' + show(v.p), cents: v.p * n, net: net(v.p) * n });
      posCents += v.p * n;
      p._variant = v;
      if (p.type === 'stick') {
        var sv = p.setup === 'neu' ? svcVar('Stickprogramm ' + progKey(p)) : p.setup === 'datei' ? svcVar('Vorhandene Stickdatei') : null;
        if (sv) setups.push({ v: sv, pi: pi, label: (p.setup === 'neu' ? 'Stickprogramm ' + progKey(p) : 'Stickdatei einrichten') + ' (einmalig)' });
      }
      if (p.grafik) {
        var gv = svcVar(p.grafik);
        if (gv) setups.push({ v: gv, pi: pi, label: p.grafik + ' (einmalig)' });
      }
    });
    setups.forEach(function (s) { lines.push({ label: s.label, detail: 'Position ' + (s.pi + 1), cents: s.v.p, net: net(s.v.p) }); });
    if (CAP && state.positions.some(function (p) { return p.motiv === 'Z'; }) && !state.positions.some(function (p) { return p.pos === 'Front'; }))
      errors.push('Der Zusatzstick Seite/Rücken (Z) ist nur zusammen mit einem Frontstick möglich. Wähle sonst „A · Schriftzug / Name“.');
    var dtfZ = state.positions.filter(function (p) { return p.type === 'druck' && p.motiv === 'Z'; }).length;
    if (dtfZ && dtfZ === state.positions.length) errors.push('Ärmel- oder Nackendruck ist nur zusätzlich zu einer weiteren Position möglich.');
    var sum = lines.reduce(function (a, x) { return a + x.cents; }, 0);
    return { n: n, liste: l, stufe: st, lines: lines, sum: sum, setups: setups, items: items, errors: errors.filter(function (e, i, a) { return a.indexOf(e) === i; }) };
  }
  function nextTierHint(n) {
    var marks = isB2B() ? [5, 10, 25, 50] : [5, 10, 25, 50];
    for (var i = 0; i < marks.length; i++) if (n < marks[i]) return 'Noch ' + (marks[i] - n) + ' Stück bis zur nächsten Preisstufe (ab ' + marks[i] + ' Stück).';
    return 'Du bist in der günstigsten Staffel (ab 50 Stück).';
  }

  /* ---------- Darstellung ---------- */
  function render() {
    var c = calc();
    // Stückpreise je Größe
    var l = c.liste;
    root.querySelectorAll('[data-unit]').forEach(function (span) {
      var r = state.rows[parseInt(span.getAttribute('data-row'), 10)];
      var map = r && state.cache[key(r.color, l)];
      var v = map && map[span.getAttribute('data-unit')];
      var inp = span.parentNode.querySelector('input');
      if (map && (!v || !v.id)) { span.textContent = 'nicht lieferbar'; inp.disabled = true; }
      else { span.textContent = v ? show(v.price) : ''; inp.disabled = false; }
    });
    // Preise in den Motiv-Auswahlen
    state.positions.forEach(function (p, pi) {
      var ms = root.querySelector('[data-motif="' + pi + '"]');
      if (ms) Array.prototype.forEach.call(ms.options, function (o) {
        var v = p.type === 'stick' ? stickVar(o.value, c.stufe, p.pos) : druckVar(o.value, c.stufe);
        var base = p.type === 'stick' ? STICK_MOTIV[o.value] : DRUCK_MOTIV[o.value];
        o.textContent = o.value + ' · ' + base + (v ? ' – ' + show(v.p) : '');
      });
      var ss = root.querySelector('[data-setup="' + pi + '"]');
      if (ss) Array.prototype.forEach.call(ss.options, function (o) {
        var v = o.value === 'neu' ? svcVar('Stickprogramm ' + progKey(p)) : o.value === 'datei' ? svcVar('Vorhandene Stickdatei') : null;
        o.textContent = SETUP[o.value] + (v ? ' – ' + show(v.p) + ' einmalig' : ' – 0 €');
      });
      var gs = root.querySelector('[data-grafik="' + pi + '"]');
      if (gs) Array.prototype.forEach.call(gs.options, function (o) {
        if (!o.value) return;
        var v = svcVar(o.value);
        o.textContent = (o.value === 'Freistellen' ? 'Freistellen / Hintergrund entfernen' : 'Vektorisieren (einfaches Logo)') + (v ? ' – ' + show(v.p) + ' einmalig' : '');
      });
      var pp = root.querySelector('[data-posprice="' + pi + '"]');
      if (pp) pp.textContent = p._variant ? show(p._variant.p) + ' je Stück' + (!CAP && p.type === 'stick' && ERSCHWERT.indexOf(p.pos) > -1 ? ' (inkl. Zuschlag erschwerte Position)' : '') + (isB2B() ? ' netto' : '') : '';
    });
    // Zusammenfassung
    var b2b = isB2B();
    var html = '<p class="kfg__tier"><strong>' + c.n + ' Stück</strong> · ' +
      (b2b ? 'Preisliste ' + esc(c.liste.replace('Gewerbe ', 'Gewerbe, ')) + ' Stück' : 'Privatkunden') +
      ' · Veredelung ' + esc(c.stufe.replace(/^(Privat|Gewerbe) /, '')) + ' Stück</p>';
    if (c.n) html += '<p class="muted small">' + nextTierHint(c.n) + '</p>';
    html += '<table class="kfg__table"><tbody>';
    c.lines.forEach(function (x) {
      html += '<tr><td>' + esc(x.label) + '<br><span class="muted small">' + esc(x.detail) + '</span></td><td class="r">' + (b2b ? fmt(x.net) : fmt(x.cents)) + '</td></tr>';
    });
    if (!c.lines.length) html += '<tr><td class="muted">Noch keine Stückzahl eingetragen.</td><td></td></tr>';
    html += '</tbody><tfoot>';
    if (b2b) {
      var netSum = c.lines.reduce(function (a, x) { return a + x.net; }, 0);
      html += '<tr><th>Summe netto</th><th class="r">' + fmt(netSum) + '</th></tr>';
      html += '<tr><td class="muted small">zzgl. MwSt.</td><td class="r muted small">' + fmt(c.sum - netSum) + '</td></tr>';
      html += '<tr><td class="muted small">Summe brutto</td><td class="r muted small">' + fmt(c.sum) + '</td></tr>';
      if (c.n) html += '<tr><td class="muted small">je Stück netto</td><td class="r muted small">' + fmt(Math.round(netSum / c.n)) + '</td></tr>';
    } else {
      html += '<tr><th>Summe inkl. MwSt.</th><th class="r">' + fmt(c.sum) + '</th></tr>';
      if (c.n) html += '<tr><td class="muted small">je Stück</td><td class="r muted small">' + fmt(Math.round(c.sum / c.n)) + '</td></tr>';
    }
    html += '</tfoot></table>';
    if (!state.positions.length && c.n) html += '<p class="note small">Ohne Position bestellst du nur das Textil – ohne Veredelung.</p>';
    el.summary.innerHTML = html;
    var errs = c.errors.filter(function (e) { return e.indexOf('geladen') === -1; });
    el.error.hidden = !errs.length;
    el.error.textContent = errs.join(' ');
    el.add.disabled = !c.n || c.errors.length > 0 || state.loading > 0;
    return c;
  }

  /* ---------- Warenkorb ---------- */
  function cfgId() { return 'K-' + Math.random().toString(36).slice(2, 7).toUpperCase(); }
  function post(path, body, isForm) {
    return fetch(ROOT_URL + path, {
      method: 'POST', credentials: 'same-origin',
      headers: isForm ? { 'Accept': 'application/json' } : { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: isForm ? body : JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Fehler'); return j; }); });
  }
  function rollback(id) {
    return fetch(ROOT_URL + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var up = {};
      cart.items.forEach(function (it) { if (it.properties && it.properties._gw_cfg === id) up[it.key] = 0; });
      if (Object.keys(up).length) return post('cart/update.js', { updates: up });
    }).catch(function () {});
  }
  el.add.addEventListener('click', function () {
    var c = render();
    if (el.add.disabled) return;
    var id = cfgId();
    var base = { 'Konfiguration': id, '_gw_cfg': id };
    el.add.disabled = true; el.add.textContent = 'Wird hinzugefügt …';
    var textileItems = c.items.map(function (it) { return { id: it.id, quantity: it.quantity, properties: base }; });
    var chain = post('cart/add.js', { items: textileItems });
    state.positions.forEach(function (p, pi) {
      chain = chain.then(function () {
        var fd = new FormData();
        fd.append('id', p._variant.id);
        fd.append('quantity', c.n);
        fd.append('properties[Konfiguration]', id);
        fd.append('properties[Position]', (pi + 1) + ' · ' + p.pos);
        if (p.type === 'stick') fd.append('properties[Stickprogramm]', SETUP[p.setup]);
        if (p.note) fd.append('properties[Hinweis]', p.note);
        if (p.file) fd.append('properties[Motiv-Datei]', p.file);
        fd.append('properties[_gw_cfg]', id);
        return post('cart/add.js', fd, true);
      });
    });
    if (c.setups.length) {
      chain = chain.then(function () {
        return post('cart/add.js', { items: c.setups.map(function (s) {
          var pr = {}; pr['Konfiguration'] = id; pr['Für'] = 'Position ' + (s.pi + 1) + ' · ' + state.positions[s.pi].pos; pr['_gw_cfg'] = id;
          return { id: s.v.id, quantity: 1, properties: pr };
        }) });
      });
    }
    chain.then(function () {
      window.location.href = ROOT_URL + 'cart';
    }).catch(function (err) {
      rollback(id).then(function () {
        el.error.hidden = false;
        el.error.textContent = 'Das hat nicht geklappt: ' + err.message + ' Bitte versuche es erneut oder schreib uns.';
        el.add.textContent = 'In den Warenkorb';
        render();
      });
    });
  });

  /* ---------- Start ---------- */
  el.addColor.addEventListener('click', function () { addRow(); });
  el.addPos.addEventListener('click', function () { addPosition('stick'); });
  document.addEventListener('gw:audience', function () { ensurePrices(); });
  var start = D.colors[0] && D.colors[0].name;
  try { var u = new URL(window.location.href); var vc = u.searchParams.get('farbe'); if (vc && colorByName(vc)) start = vc; } catch (e) {}
  addRow(start);
  addPosition('stick');
})();
